import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TippyDirective } from '@ngneat/helipopper';

import type { NavItem } from '../../interfaces/nav-item';

@Component({
  selector: 'locumsnest-menu-list-item',
  templateUrl: './menu-list-item.component.html',
  styleUrls: ['./menu-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, NgTemplateOutlet, TippyDirective],
})
export class MenuListItemComponent {
  private readonly router = inject(Router);

  readonly idx = input.required<string>();
  readonly item = input.required<NavItem>();
  readonly menuExpanded = input.required<boolean>();
  readonly isFirstElement = input.required<boolean>();
  readonly activeNavItem = input.required<string | null>();
  readonly filtersDisabled = input.required<boolean>();
  readonly filterCount = input.required<number>();
  readonly hospitalOfficerPath = input.required<string>();
  readonly nestPanelExpanded = input.required<boolean>();
  readonly itemListLength = input.required<number>();
  readonly isAgencyPlatform = input.required<boolean>();

  readonly toggled = output<string>();
  readonly clicked = output<string>();
  readonly filterMenuClicked = output();

  readonly isActive = computed(() =>
    this.item().code === 'nest'
      ? this.nestPanelExpanded()
      : this.item().code === this.activeNavItem(),
  );

  // A whole URL, not route commands: following it closes any open side panel (named outlet), and
  // a path declared without a leading slash still resolves from the app root.
  readonly link = computed(() => {
    const item = this.item();
    const path = item.code === 'settings' ? this.hospitalOfficerPath() : item.path;
    return path ? this.router.parseUrl(path) : null;
  });

  onItemSelected() {
    const item = this.item();
    if (!item.hasRightMenu) this.clicked.emit(item.displayName);
    if (item.hasRightMenu && item.code !== 'filters') {
      this.toggled.emit(item.displayName);
    }
    if (item.code === 'filters' && !this.filtersDisabled()) {
      this.filterMenuClicked.emit();
    }
  }
}
